import React, { useState } from 'react';
import { useOnboarding } from '../context/OnboardingContext';
import PageLayout from '../components/PageLayout';
import NavigationButtons from '../components/NavigationButtons';
import { SPORT_LABELS, sportEmoji } from '../constants/sports';
import './OnboardingSport.css';

const MAX_SPORTS = 10;

const OnboardingSport = () => {
  const { formData, updateField } = useOnboarding();
  const selected = formData.sport;
  const atLimit = selected.length >= MAX_SPORTS;

  // Sports saisis librement (Hyrox, pole dance, discipline de niche…) : ils
  // s'affichent comme les autres et sont enregistrés dans sports_list.
  const [customSport, setCustomSport] = useState('');
  const customSelected = selected.filter((s) => !SPORT_LABELS.includes(s));

  const toggle = (sport) => {
    if (selected.includes(sport)) {
      updateField('sport', selected.filter((s) => s !== sport));
    } else if (!atLimit) {
      updateField('sport', [...selected, sport]);
    }
  };

  const addCustomSport = () => {
    const label = customSport.trim();
    if (!label || atLimit) return;
    // Comparaison insensible à la casse pour éviter « hyrox » ET « Hyrox ».
    const already = selected.some((s) => s.toLowerCase() === label.toLowerCase());
    if (!already) updateField('sport', [...selected, label]);
    setCustomSport('');
  };

  return (
    <PageLayout step={4}>
      <h2 className="title">Quel sport pratiquez-vous ?</h2>
      <p className="subtitle">Sélectionnez jusqu'à {MAX_SPORTS} sports</p>

      <div className="sport-chips">
        {[...SPORT_LABELS, ...customSelected].map((opt) => {
          const isSelected = selected.includes(opt);
          const isDisabled = !isSelected && atLimit;
          return (
            <button
              key={opt}
              type="button"
              disabled={isDisabled}
              className={`sport-chip${isSelected ? ' sport-chip--selected' : ''}`}
              onClick={() => toggle(opt)}
            >
              <span className="sport-chip__emoji" aria-hidden="true">{sportEmoji(opt)}</span>
              <span className="sport-chip__label">{opt}</span>
            </button>
          );
        })}
      </div>

      <div className="sport-custom">
        <label className="sport-custom__label" htmlFor="sport-autre">
          Votre sport n'est pas listé ?
        </label>
        <div className="sport-custom__row">
          <input
            id="sport-autre"
            name="sport-autre"
            type="text"
            className="form-input sport-custom__input"
            placeholder="Ex : Hyrox, pole dance…"
            value={customSport}
            maxLength={40}
            disabled={atLimit}
            onChange={(e) => setCustomSport(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                addCustomSport();
              }
            }}
          />
          <button
            type="button"
            className="sport-custom__add"
            onClick={addCustomSport}
            disabled={!customSport.trim() || atLimit}
          >
            Ajouter
          </button>
        </div>
      </div>

      <div className="form-group form-group--left">
        <p className="level-label">À quel niveau ?</p>
        <select
          id="niveau-sportif"
          name="niveau"
          value={formData.level}
          onChange={(e) => updateField('level', e.target.value)}
          className="form-input form-select"
        >
          <option value="">Sélectionner un niveau</option>
          <option value="Débutante">Débutante</option>
          <option value="Intermédiaire">Intermédiaire</option>
          <option value="Confirmée">Confirmée</option>
          <option value="Professionnelle">Professionnelle</option>
        </select>
      </div>

      <NavigationButtons
        nextPath="/onboarding/contraception"
        prevPath="/onboarding/poids"
      />
    </PageLayout>
  );
};

export default OnboardingSport;
